module.exports = __webpack_public_path__ + "img/head.c3b9afb0.png";